import React from 'react';
import { Link } from 'lucide-react';
import { OnboardingStatusBanner } from './OnboardingStatusBanner';

interface IntegrationsStatusBannerProps {
  organization: any;
}

export const IntegrationsStatusBanner: React.FC<IntegrationsStatusBannerProps> = ({
  organization,
}) => {
  // Don't show if Stage 5 (CRM Integrations) hasn't been completed yet
  const stage5Completed = organization?.onboardingSetup?.stage5?.completed;
  if (!stage5Completed) return null;

  // Get CRM entries from onboarding data
  const crmEntries = organization?.onboardingData?.crm?.crm_entries || [];

  // Check if FUB (Follow Up Boss) was selected - they set up their own integration
  const hasFubSelected = crmEntries.some(
    (entry: { crm_type?: string }) => entry.crm_type === 'fub'
  );

  // Don't show banner if FUB was selected (they set it up themselves)
  if (hasFubSelected) {
    return null;
  }

  // Check if sync_link is already set (integration complete)
  const hasSyncLink = Boolean(organization?.sync_link && organization.sync_link.trim() !== '');

  // Don't show banner if sync link is already set
  if (hasSyncLink) {
    return null;
  }

  return (
    <OnboardingStatusBanner
      icon={Link}
      title="Integrations Setup in Progress"
      variant="green"
      iconClassName="animate-pulse"
      iconAnimation={{ animationDuration: '2s' }}
    >
      <p className="text-xs">
        Our team is currently working on setting up your CRM integration. You will be notified once
        the setup is complete and review during your strategy call.
      </p>
    </OnboardingStatusBanner>
  );
};
